import intl from 'react-intl-universal';
import { useEffect, useRef, useState } from 'react';
import { useModel } from '@umijs/max';
import {
    history,
    useLocation,
    useAppData,
    matchRoutes,
    useParams,
} from '@umijs/max';
// import classNames from 'classnames';
import type { TabType } from '@/typing';
import { ReactSortable } from 'react-sortablejs';
import {
    LeftOutlined,
    RightOutlined,
    EllipsisOutlined,
} from '@ant-design/icons';

import styles from './index.less';
import Tab from './tab';
import { Popover } from 'antd';
import { debounce } from 'lodash';

type TabsProps = {
    className?: any;
};

type ChildRefItem = { node: TabType; target: HTMLDivElement };

const Tabs: React.FC<TabsProps> = () => {
    const location = useLocation();
    const appData = useAppData();
    const { clientRoutes } = appData;
    const homePath = '/index';
    const tabsModel = useModel('tabRoutes');
    const {
        initialState: { userInfo },
    } = useModel('@@initialState');
    const params = useParams();
    const childsRef = useRef<ChildRefItem[]>([]);
    const containerDom = useRef<HTMLDivElement | null>(null);
    const [unClientTabs, setUnClientTabs] = useState([]);
    const [isShowMore, setIsShowMore] = useState(false);
    const [isShowLeftRightBtn, setIsShowLeftRightBtn] = useState(false);

    const getChildRef = (ref: ChildRefItem) => {
        if (ref) {
            // const target = childsRef.current?.find(
            //     (item) => item.node?.path === ref.node?.path,
            // );

            const targetIndex = childsRef.current.findIndex(
                (item) => item.node?.path === ref.node?.path,
            );
            if (targetIndex === -1) {
                childsRef.current.push(ref);
            } else {
                childsRef.current.splice(targetIndex, 1, ref);
            }
        }
    };

    useEffect(() => {
        // const tab = document.getElementById('layout-tab');
        const tab = containerDom.current;
        const wheel = (event) => {
            event.preventDefault();
            tab.scrollLeft += event.deltaY;
        };

        const scroll = debounce((event) => {
            event.preventDefault();
            getUnClientTabs();
        }, 2000);

        tab?.addEventListener('wheel', wheel);
        tab?.addEventListener('scroll', scroll);

        window.onresize = function () {
            getUnClientTabs();
            showLeftRightBtn();
        };

        // return () => {
        //     tab?.removeEventListener('wheel', wheel);
        //     tab?.removeEventListener('scroll', scroll);
        //     window.onresize = null;
        // };
    }, [containerDom, tabsModel.tabs]);

    useEffect(() => {
        const routes = matchRoutes(clientRoutes, location.pathname);
        const currentRoute = routes?.[routes.length - 1]?.route || null;

        // console.log(currentRoute);

        if (currentRoute && !currentRoute.hideInTab) {
            // 页面不缓存时，始终更新第一个 tab
            // 1.1.2 需求更新，每个页面都单开tab
            // if (!currentRoute.newTab) {
            //     if (tabsModel.tabs[0]?.path !== location.pathname) {
            //         tabsModel.editTabs(0, {
            //             title: getTitle(currentRoute.name),
            //             name: currentRoute.name,
            //             path: location.pathname,
            //             alive: currentRoute.alive,
            //         });
            //     }
            // } else {

            // let path = location.pathname + location.search;
            // if (currentRoute.multiTab && !location.search) {
            //     path = location.pathname + '?=' + new Date().getTime();
            //     history.push(path);
            //     return;
            // }

            console.log('-=-=--=', currentRoute);
            tabsModel.addTabs({
                title: getTitle(currentRoute),
                name: currentRoute.name,
                path: location.pathname,
                alive: currentRoute.alive,
                search: location.search,
            });

            const targetTab = tabsModel.tabs?.find(
                (item) => item?.path === location.pathname,
            );
            if (targetTab) {
                scrollToTab();
            }
        }
    }, [location]);

    useEffect(() => {
        scrollToTab();
        showLeftRightBtn();
        setIsShowMore(false);
    }, [tabsModel.tabs]);

    const showLeftRightBtn = () => {
        const tabScrollWidth = Math.round(
            containerDom.current?.scrollWidth || 0,
        );
        const tabClientWidth = Math.round(
            containerDom.current?.clientWidth || 0,
        );
        if (tabScrollWidth > tabClientWidth) {
            setIsShowLeftRightBtn(true);
        } else {
            setIsShowLeftRightBtn(false);
        }
    };

    const scrollToTab = () => {
        const targetTab = childsRef.current?.find(
            (item) => item.node?.path === location.pathname,
        );
        const target: HTMLDivElement | null = targetTab?.target || null;
        const containerWidth = containerDom.current?.clientWidth || 0;
        const offsetLeft = target?.offsetLeft || 0;
        const targetWidth = target?.clientWidth || 0;
        containerDom.current?.scrollTo({
            left: offsetLeft + targetWidth - containerWidth,
            behavior: 'smooth',
        });

        setTimeout(() => {
            getUnClientTabs();
        }, 2000);
        setIsShowMore(false);
    };

    const getUnClientTabs = () => {
        let containerCurrent = containerDom.current;
        // 遍历每个元素并判断是否在可视区内
        let unTabsTitle = [];
        childsRef.current?.forEach((element) => {
            if (
                element.target?.offsetLeft >
                Math.round(containerCurrent?.scrollLeft || 0) +
                    containerCurrent?.clientWidth +
                    200
            ) {
                unTabsTitle.push(element.target.outerText);
            }
        });
        let unTabsNode = [];
        tabsModel.tabs.forEach((item) => {
            if (unTabsTitle.includes(item.title)) {
                unTabsNode.push(item);
            }
        });
        setUnClientTabs(unTabsNode);
    };

    const scrollLeft = () => {
        const tabScrollLeft = Math.round(containerDom.current?.scrollLeft || 0);
        const tabClientWidth = Math.round(
            containerDom.current?.clientWidth || 0,
        );
        containerDom.current?.scrollTo({
            left:
                tabScrollLeft - tabClientWidth > 0
                    ? tabScrollLeft - tabClientWidth + 60
                    : 0,
            behavior: 'smooth',
        });
        setTimeout(() => {
            getUnClientTabs();
        }, 2000);
    };

    const scrollRight = () => {
        const tabScrollLeft = Math.round(containerDom.current?.scrollLeft || 0);
        const tabScrollWidth = Math.round(
            containerDom.current?.scrollWidth || 0,
        );
        const tabClientWidth = Math.round(
            containerDom.current?.clientWidth || 0,
        );
        containerDom.current?.scrollTo({
            left:
                tabScrollWidth - tabScrollLeft > tabClientWidth
                    ? tabScrollLeft + tabClientWidth - 60
                    : tabScrollLeft,
            behavior: 'smooth',
        });
        setTimeout(() => {
            getUnClientTabs();
        }, 2000);
    };

    const showMoreMenu = () => {
        getUnClientTabs();
        setIsShowMore(!isShowMore);
    };

    const handleOpenChange = (newOpen: boolean) => {
        setIsShowMore(newOpen);
    };

    const getTabName = (name: string) => {
        return name ? intl.get(`meun.${name}`) || intl.get(name) : name;
    };

    // 页面标题
    const getTitle = (currentRoute) => {
        const name = currentRoute.name;

        if (currentRoute.path === '*') {
            // 这里返回权限配置的名称
            const assessRoute = userInfo?.menuData?.find((item) => {
                return item.path?.split('?')[0] === location.pathname;
            });
            if (assessRoute) {
                return getTabName(assessRoute.name);
            }
            return getTabName(name);
        }

        if (!params.id) {
            return getTabName(name);
        }

        const stringID = params.id + '';
        if (stringID.length > 4) {
            return `${getTabName(name)} ...${stringID.substring(
                stringID.length - 4 || 0,
            )}`;
        } else {
            return `${getTabName(name)} ...${stringID}`;
        }
    };

    // 关闭当前
    const closeTab = (node: TabType) => {
        // 如果关闭的是当前激活页签
        if (location.pathname === node.path) {
            if (tabsModel.tabs.length === 1) {
                if (node.path === homePath) {
                    return;
                }
                history.push(homePath);
            } else {
                const index = tabsModel.tabs.findIndex(
                    (item) => item.path === node.path,
                );
                const newIndex = index === 0 ? 1 : index - 1;
                history.push(tabsModel.tabs[newIndex].path);
            }
        }
        tabsModel.removeTabs(node);
        setIsShowMore(false);
    };

    // 关闭其它
    const closeOtherTab = (node: TabType) => {
        history.push(node.path);

        tabsModel.tabs.forEach((item) => {
            if (item.path !== node.path) {
                tabsModel.removeTabs(item);
            }
        });
        setIsShowMore(false);
    };

    // 关闭所有
    const closeAllTab = () => {
        tabsModel.removeAllTabs();
        history.push(homePath);
        setIsShowMore(false);
    };

    return (
        <div className={styles.tabsWrap}>
            {isShowLeftRightBtn && (
                <div className={styles.tabsLeft}>
                    <LeftOutlined onClick={scrollLeft} />
                </div>
            )}
            <div
                ref={containerDom}
                className={styles.tabs}
            >
                <ReactSortable
                    style={{ display: 'flex' }}
                    list={tabsModel.tabs}
                    setList={(list) => {
                        console.log('ReactSortable===', list);
                        if (list.length) {
                            tabsModel.setTabs(list);
                        }
                    }}
                >
                    {tabsModel.tabs.map((node) => {
                        if (node?.path !== '/') {
                            return (
                                <Tab
                                    node={node}
                                    key={node.path}
                                    ref={getChildRef}
                                    closeable={true}
                                    closeTab={() => closeTab(node)}
                                    closeOtherTab={() => closeOtherTab(node)}
                                    closeAllTab={closeAllTab}
                                />
                            );
                        }
                        return <></>;
                    })}
                </ReactSortable>
            </div>

            <div className={styles.tabsRight}>
                {isShowLeftRightBtn && (
                    <RightOutlined onClick={() => scrollRight()} />
                )}
                {unClientTabs.length > 0 ? (
                    <Popover
                        open={isShowMore}
                        trigger="click"
                        placement="bottomRight"
                        onOpenChange={handleOpenChange}
                        content={
                            <div className={styles.unClientTabsWarp}>
                                {unClientTabs.map((node, index) => {
                                    if (index < 15 && node?.path !== '/') {
                                        return (
                                            <Tab
                                                node={node}
                                                key={node.path}
                                                closeable={true}
                                                closeTab={() => closeTab(node)}
                                                closeOtherTab={() =>
                                                    closeOtherTab(node)
                                                }
                                                closeAllTab={closeAllTab}
                                            />
                                        );
                                    }
                                    if (index === 15) {
                                        return (
                                            <div
                                                key={index}
                                                className={styles.omitMore}
                                            >
                                                . . .
                                            </div>
                                        );
                                    }
                                    return '';
                                })}
                            </div>
                        }
                    >
                        <EllipsisOutlined
                            className={styles.tabsMore}
                            onClick={() => showMoreMenu()}
                        />
                    </Popover>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
};

export default Tabs;
